module.exports = __webpack_public_path__ + "img/about5.1fde13ee.png";